<template>
    <div>
        <b-navbar toggleable="md" class="navbar">
            <b-navbar-brand class="col-md-3">
                <router-link to="/">
                    <img class="logo" src="@/assets/clubsaway-logo-mobile.svg">
                </router-link>

                <!-- clubsaway logo -->
            </b-navbar-brand>
            <b-navbar-toggle target="nav_collapse"/>

            <b-collapse is-nav id="nav_collapse">
                <b-navbar-nav>
                    <b-nav-item :to="'/admin/users'">
                        Manage Users
                    </b-nav-item>

                    <b-nav-item :to="'/admin/clients'">
                        Manage Clients
                    </b-nav-item>

                    <b-nav-item :to="'/admin/events'">
                        Manage Events
                    </b-nav-item>
                </b-navbar-nav>

                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown right>
                        <template slot="button-content">
                            {{ user.name }}
                        </template>

                        <b-dropdown-item>
                            <b-button @click="logout()">
                                Log Out
                            </b-button>
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

<!--        <breadcrumbs/>-->

        <div class="py-5">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            user() {
                return this.$store.getters.user;
            }
        },

        methods: {
            logout() {
                api.get('/logout')
                    .then(response=>{
                        window.location = '/';
                        //
                    });
            }
        }
    }
</script>

<style scoped>
    .logo {
        max-width: 300px;
    }
    a.router-link-active {
        color: white!important;
    }
</style>